import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { TableHeaderCellProvider } from '../../js/TableHeaderCellContext';
export var StyledTableBody = /*#__PURE__*/styled.tbody.withConfig({
  displayName: "StyledTableBody",
  componentId: "c11n-8-64-0__sc-8i1s74-0"
})([""]);
/**
 * TableBody
 *
 * @since 8.0.0
 */

var TableBody = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableHeaderCellProvider, {
    value: {
      parent: 'body'
    }
  }, /*#__PURE__*/React.createElement(StyledTableBody, _extends({
    ref: ref
  }, props)));
});
TableBody.displayName = 'Table.Body';
/** @component */

export default TableBody;